import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import MyStorage from '../../common/MyStorage';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import MenuBar from '../../components/menu-bar/MenuBar';
import { WebApiCalls } from '../../webApiCalls/webApiCalls';
import {
    UpdateCartCount,
    UpdateCartAmount
} from "../../redux/actions/postActions";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { KMTracking, KMIdentifier } from '../../components/Tracking/KMTracking';

function Login(props) {
    const [is_loading, setIsLoading] = useState(false)
    const [userName, setUserName] = useState('')

    const [show_userName_error, setShowUserNameError] = useState(false)
    const [userName_error_text, setUserNameErrorText] = useState('')

    const [password, setPassword] = useState('')
    const [show_password_error, setShowPasswordError] = useState(false)
    const [password_error_text, setPasswordErrorText] = useState('')

    const [show_api_error, setShowApiError] = useState(false)
    const [api_error, setApiError] = useState('')
    const [password_type, setPasswordType] = useState(true)

    const storage = new MyStorage();
    useEffect(() => {
        const listener = event => {
          if (event.code === "Enter" || event.code === "NumpadEnter") {
            event.preventDefault();
                login() 
          }
        };
        document.addEventListener("keydown", listener);
        return () => {
          document.removeEventListener("keydown", listener);
        };
      }, [userName,password]);
    const tracker = async (eventName, _kmprops) => {
        await KMTracking(eventName, _kmprops)
    }

    const login = () => {
        if (userName == '') {
            setShowUserNameError(true)
            setUserNameErrorText('Please enter your username')
            return
        } else if (password == '') {
            setShowPasswordError(true)
            setPasswordErrorText('Please enter password')
            return
        }
        // console.log('&&&**** username Password', userName, password)
        setIsLoading(true)
        new WebApiCalls().LoginUser(userName, password).then(result => {
            //  console.log('result LoginUser', result)
            if (result?.data) {
                fetchingToken(result.data);
            } else if (!result.data) {
                setIsLoading(false)
                storage.setloggedIn("false")
                setShowApiError(true)
                if (result.error.includes('Invalid member'))
                    setApiError('Invalid username or password')
                else
                    setApiError(result.error)
            }
            else {
                setIsLoading(false)
                storage.setloggedIn("false")
            }
        }).catch(error => {
            setIsLoading(false)
            console.log('Error: ', error);
            storage.setloggedIn("false")
        })
    }
    const fetchingToken = async (data) => {
        const storage = new MyStorage();        
        let obj = {
            contactID: data.memberInfo.contact_id,
            email: data.memberInfo.email,
            authentication: data.jwt,
            phoneNumber: data.memberInfo.mobile,
            name: data.memberInfo?.givenname + ' ' + data.memberInfo?.familyname
        };
        storage.setloggedIn("true")
        storage.setContactIDFrasers(data.memberInfo.contact_id)
        // storage.setEmailFrasers(data.memberInfo.email)
        storage.setauthenticationFrasers(obj.authentication)
        // storage.setPhoneNumber(data.memberInfo.mobile)
        storage.setName(data.memberInfo.givenname)
        await KMIdentifier(obj.contactID)
        await new WebApiCalls().getToken(obj).then(async (response) => {
            // console.log('getToken response', response)
            if (response.AccessToken) {
                storage.setUserId(response.AccessToken.UserId);
                storage.setaccess_token(response.AccessToken.access_token)
                storage.setSsoCode(response.SsoCode)
            } else {
                setIsLoading(false)
            }
            let body = {
                FirstName: data.memberInfo.givenname,
                LastName: data.memberInfo.lastName,
                DisplayName: data.memberInfo.givenname,
                PhoneNumber: data.memberInfo.mobile,
                Description: data.memberInfo.contact_id
            }
            await new WebApiCalls()
                .updateUserInfo(response?.AccessToken?.UserId, body, response?.AccessToken?.access_token).then((updateUserResult) => {
                    // console.log('updateUserInfo result', updateUserResult)
                    setIsLoading(false)
                    let eventData = {
                        CurentPage: 'Login',
                        source: props?.location?.state?.from ? props?.location?.state?.from : '',
                        Contact_ID: data.memberInfo.contact_id
                    }
                    tracker("LoggedIn", eventData)
                    tracker("login", eventData)
                    props?.history?.push(`/`)
                }).catch(error => {
                    setIsLoading(false)
                    console.log('Error in updateUserInfo', error)
                })

            // await new WebApiCalls()
            //     .getUserInfo(response.AccessToken.UserId,
            //         response.AccessToken.access_token)
            //     .then(async (getUserResult) => {
            //         console.log('getUserInfo result', getUserResult)

            //         // this.props.addUserData(response);
            //         // await this.seeCart();
            //     });
        });
    }
    const handleUserName = (event) => {
        setShowUserNameError(false)
        setShowApiError(false)
        setUserName(event.target.value)
    }
    const handlePassword = (event) => {
        setShowPasswordError(false)
        setShowApiError(false)
        setPassword(event.target.value)
    }
    // if (userName) {
    //     console.log('userName', userName)
    // }
    const ErrorView = (_text) => {
        return (<div className="error" style={{ display: "block", marginTop: 10 }}>{_text}</div>)
    }
    return (
        <div>
            <div className="viewport"></div>

            {/* /container */}
            <div className="container">

                {/* header */}
                <Header props={props} />
                {/* /header */}

                <MenuBar props={props} categoriesArray={props?.allCategories ? props?.allCategories : []}/>

                {/* login */}
                <div className="login">
                    <div className="title">Sign In with Frasers Experience</div>

                    <form name="login">

                        <fieldset>
                            <label htmlFor="">MOBILE NO. OR EMAIL</label>
                            <input type="text" name="id" value={userName} onChange={handleUserName} id="id" />
                            {
                                show_userName_error &&
                                ErrorView(userName_error_text)}
                        </fieldset>

                        <fieldset className="pw-field">
                            <label htmlFor="">PASSWORD</label>
                            <input type={password_type ? 'password' : 'text'} onChange={handlePassword} value={password} className="pw" name="password" id="password"/>
                            <div className="visibility" onClick={() => setPasswordType(!password_type)}><img src={password_type ? "images/icon-invisible.svg" : "images/icon-visible.svg"} alt="" /></div>
                            {
                                show_password_error &&
                                ErrorView(password_error_text)}
                            {
                                show_api_error &&
                                ErrorView(api_error)}
                        </fieldset>

                        <div onClick={(event) => {
                            event.preventDefault()
                            login()
                        }} className="loadingBlackButton">
                            {
                                is_loading ?
                                    <Loader
                                        type="TailSpin"
                                        color="white"
                                        height={18}
                                        width={18}
                                    />
                                    :
                                    "NEXT"}
                        </div>
                    </form>

                    <a onClick={() => {
                        props?.history?.push("/reset-pw")
                    }} className="forgotpw">Forgot password?</a>

                    <div className="join">
                        New to Frasers Experience?
                        <a onClick={() => {
                            props?.history?.push("/sign-up", { from: 'Login' })
                        }}> Join Now</a>
                    </div>

                </div>
                {/* /login */}

            </div>
            {/* /container */}

            <Footer categoriesArray={props?.allCategories ? props?.allCategories : []} />


        </div>
    )
}
const mapStateToProps = (state) => {
    const { cart_count,allCategories } = state.UserReducer
    return { cart_count,allCategories }
};
const actions = {
    UpdateCartCount,
    UpdateCartAmount
};
export default connect(mapStateToProps, actions)(Login);